export default "__VITE_ASSET__GCWN28EK__"